import Budgeting from '../../../views/Finance/Budgeting/Budgeting.finance.view';

export default Budgeting;
